export var DURATION_VALUES = {
  short: '0.2s',
  medium: '0.6s',
  long: '1.2s'
};